// extracted by mini-css-extract-plugin
export default {"loadingContainer":"callback_loadingContainer__w7Wt-","loadingSpinner":"callback_loadingSpinner__t8PHK","spin":"callback_spin__LOZ-B","loadingText":"callback_loadingText__caMPF"};